import "./bootstrap";

import * as Sentry from "@sentry/react";

window.Sentry = Sentry;

Sentry.init({
  dsn: "https://572602a81109806453182d244e109cb1@o4509235901890560.ingest.us.sentry.io/4511373079609344",
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/dashboard\.theitoons\.com/],
});

// Test Sentry integration — fires on page load
Sentry.captureMessage("Sentry is configured successfully on theitoons-dashboard", "info");


